export default {
    //ChangeSubscriptionComponent
    info_promotional_coupon: 'Tens un cupó promocional? Fes clic a "Activar" per utilitzar-lo. ',

    //CurrentSubscriptionComponent
    canceled_message: 'El vostre compte ha estat cancel·lat. Subscriviu-vos a un pla per tornar a activar el vostre compte.',

    //StripeNumberComponent
    change_pay_method: 'Canviar mètode de pagament',
}